module.exports = __webpack_public_path__ + "img/enerfy_logo.a7d8ccde.svg";